function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Ico06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.2 73.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M72.28,36.6c0,2.19-1.78,3.96-3.97,3.96s-3.96-1.77-3.96-3.96,1.77-3.97,3.96-3.97,3.97,1.77,3.97,3.97ZM8.84,36.6c0,2.19-1.77,3.96-3.96,3.96s-3.96-1.77-3.96-3.96,1.78-3.97,3.96-3.97,3.96,1.77,3.96,3.97ZM40.56,68.32c0,2.19-1.77,3.96-3.96,3.96s-3.96-1.77-3.96-3.96,1.77-3.96,3.96-3.96,3.96,1.77,3.96,3.96ZM40.56,4.88c0,2.19-1.77,3.96-3.96,3.96s-3.96-1.77-3.96-3.96,1.77-3.96,3.96-3.96,3.96,1.77,3.96,3.96Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6,59.07v5.29M64.35,36.6h-5.29M36.6,8.84v5.29",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.83,56.22c1.55,1.55,1.55,4.06,0,5.61-1.55,1.55-4.06,1.55-5.61,0-1.55-1.55-1.55-4.06,0-5.61,1.55-1.55,4.06-1.55,5.61,0ZM16.97,11.37c1.55,1.55,1.55,4.06,0,5.61-1.55,1.55-4.06,1.55-5.61,0-1.55-1.55-1.55-4.06,0-5.61,1.55-1.55,4.06-1.55,5.61,0Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.13,36.6h-5.29M52.49,52.48l3.74,3.74M16.97,16.97l3.74,3.74",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.83,11.37c1.55,1.55,1.55,4.06,0,5.61-1.55,1.55-4.06,1.55-5.61,0-1.55-1.55-1.55-4.06,0-5.61,1.55-1.55,4.06-1.55,5.61,0ZM16.97,56.22c1.55,1.55,1.55,4.06,0,5.61-1.55,1.55-4.06,1.55-5.61,0-1.55-1.55-1.55-4.06,0-5.61,1.55-1.55,4.06-1.55,5.61,0Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71,52.48l-3.74,3.74M56.22,16.97l-3.74,3.74",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.74,43.21h31.72M52.46,29.99h-31.72M43.21,36.6c0,9.12-2.96,16.52-6.61,16.52s-6.61-7.4-6.61-16.52,2.96-16.52,6.61-16.52,6.61,7.4,6.61,16.52ZM53.78,36.6c0,9.49-7.69,17.18-17.18,17.18s-17.18-7.69-17.18-17.18,7.69-17.18,17.18-17.18,17.18,7.69,17.18,17.18Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Ico06);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-ico-06.96089cdfceed5cf931053f33ffeacc61.svg";
export { ForwardRef as ReactComponent };